import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import AuthController from './components/AuthController';
import MainPageComponent from './components/MainPage/MainPage.container';
import PaceProgress from './components/PaceProgress/PaceProgress.container';
import SideBarComponent from './components/SideBar/SideBar.container';
import UserInfoActions from './actions/UserInfoActions';
import AdvertiserApi from './api/index';
import config from './config';
import { push } from 'utils/navigation';
import UserStore from './stores/UserStore';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-widgets/styles.css';
import 'rc-tree/assets/index.css';
import './assets/css/flag-icons.css';
import './styles/main.less';

import '@fontsource/roboto-condensed/400.css';
import '@fontsource/roboto-condensed/500.css';
import '@fontsource/roboto-condensed/600.css';
import '@fontsource/roboto-condensed/700.css';

import NavigationBinder from './utils/NavigationBinder';
import locales from './locales';
import { I18nProvider } from 'utils/I18n/context';

export default function App() {
    useEffect(() => {
        UserInfoActions.init();
        try {
            AdvertiserApi.makeRequest('/user/user.get', { queryMethod: 'GET', removeLocale: true })
                .then((resp) => {
                    if (resp && resp.error && resp.error.code === 401) {
                        push(`${config.defaultRoute}401`, { replace: true });
                    }
                })
                .catch(() => {
                });
        } catch {}
    }, []);

    const locale = (UserStore.getLocale && UserStore.getLocale()) || 'en';
    const tz = (UserStore.getTimezone && UserStore.getTimezone()) || 'UTC';

    return (
        <I18nProvider locale={locale} tz={tz} dictionaries={locales}>
            <NavigationBinder />
            <div id="wrapper">
                <ToastContainer 
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <PaceProgress />
                <AuthController />
                <div className="sidebarContainer">
                    <SideBarComponent />
                </div>
                <MainPageComponent>
                    <Outlet />
                </MainPageComponent>
            </div>
        </I18nProvider>
    );
}
